// single_post

import { eventBus, EVENTS } from '../commons/EventBus.js';
import { Slider } from '../commons/slider.js';
import Utils from './utils.js';
const INITIAL_POS = 0;
const TOLERANCE = 20;
const TRANSITION_DURATION=600;
const scrollArr=[];
let handling = false;
let data = {
    xPos: INITIAL_POS,
    partialXPos: INITIAL_POS,
    yPos: INITIAL_POS,
    partialYPos: INITIAL_POS,
    removed: false,
    ended: false
};
let root = document.documentElement;
let lastBreakpoint;


const template=`
<div id='gallery_cont'><div id="inner_gallery">
  <div id="inner_gallery_pre" class="">
      <div id="inner_gallery_gray">
          <div id="chiudi_gallery">
              <img src="https://media.rds.it/web/web-site-brandnew/svg/chiudi_gallery.svg">
          </div>
          <div class="sofia_font flex align_center justify_between" style="margin-bottom:20px;">
                  <div id="titolo_page_gallery" class="font_50 font_44_tablet font_30_mobile bold dark_font">Le 15 partite NBA che hanno fatto la storia</div>
                  <div class="hide_mobile" style="margin: 0 60px;">
                       <div class="flex align_center justify_center">
                          <span class="sofia_font font_16">Condividi</span>
                          <img class="clickable" style="width: 18px;" src="https://media.rds.it/web/web-site-brandnew/svg/icon-share.svg?p=d">
                       </div>
                        <div class="flex align_center icon_sharing_cont">
                            <div onclick="facebookShare({})" class="clickable icon_sharing_post hover_fill">
                                <svg xmlns="http://www.w3.org/2000/svg" width="7" height="16" viewBox="0 0 7 16">
                                    <path xmlns="http://www.w3.org/2000/svg" fill="#666666" d="M1.657 15.816H4.84V7.841h2.222l.237-2.67H4.841V3.65c0-.63.127-.879.736-.879H7.3V.001H5.095c-2.37 0-3.438 1.043-3.438 3.04v2.13H0v2.703h1.657v7.942z" mask="url(#5v44cz1j2b)"/>
                                </svg>
                            </div>
                            <div onclick="twitterShare()"  class="clickable icon_sharing_post hover_fill">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="13" viewBox="0 0 16 13">
                                    <path xmlns="http://www.w3.org/2000/svg" fill="#666666" d="M0 11.525C1.453 12.457 3.178 13 5.032 13c6.094 0 9.538-5.147 9.33-9.763.641-.462 1.198-1.04 1.638-1.699-.589.261-1.222.438-1.885.517.677-.406 1.198-1.048 1.442-1.816-.633.376-1.336.65-2.083.797C12.874.398 12.022 0 11.077 0 8.958 0 7.401 1.976 7.88 4.03 5.152 3.892 2.732 2.585 1.114.6.254 2.076.668 4.006 2.13 4.982c-.538-.016-1.045-.165-1.487-.41-.036 1.52 1.054 2.942 2.632 3.26-.462.125-.968.153-1.481.055.416 1.304 1.629 2.253 3.066 2.28C3.48 11.248 1.74 11.73 0 11.525" mask="url(#zy1q615njb)"/>
                                </svg>
                            </div>
                            <div onclick="copyToClipboard(this)" title="Copia link" class="clickable icon_sharing_post hover_stroke">
                                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 16 16">
                                    <defs>
                                        <filter id="iw5yew9n1a">
                                            <feColorMatrix in="SourceGraphic" values="0 0 0 0 0.400532 0 0 0 0 0.400532 0 0 0 0 0.400532 0 0 0 1.000000 0"/>
                                        </filter>
                                    </defs>
                                    <g fill="none" fill-rule="evenodd" opacity="1">
                                        <g>
                                            <g filter="" transform="translate(-1316 -470) translate(1235 427)">
                                                <g>
                                                    <path d="M0 0L16 0 16 16 0 16z" transform="translate(81 43)"/>
                                                    <path stroke="#666666" stroke-linecap="round" stroke-linejoin="round" d="M11.63 8.519l1.555-1.556c1.146-1.145 1.146-3.002 0-4.148h0c-1.145-1.146-3.002-1.146-4.148 0L7.48 4.37M5.927 10.073L10.073 5.927M4.37 7.481L2.815 9.037c-1.146 1.145-1.146 3.002 0 4.148h0c1.145 1.146 3.002 1.146 4.148 0L8.52 11.63" transform="translate(81 43)"/>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </svg>

                            </div>
                </div>
                  </div>
          </div>
          <div id="post-gallery-slider">
            <div id="post-gallery-container" class="container_flex_gallery">

            </div>
          </div>
      </div>
  </div>
</div></div>`;

eventBus.on( EVENTS.PAGE_AFTER_RENDERING, function(data) {
    const template=data.template;
    if(template!='single_post'){
        return;
    }
    ////fare controllo se presente la gallery
    if(window.gallery){
        if(location.hash && !isNaN(location.hash)){
            openGallery(Number(location.hash));
        }
        $("#immagine_in_evidenza").append("<div id='sfoglia_gallery'><span>GUARDA LA GALLERY</span><img width='24' height='24' src='https://media.rds.it/web/web-site-brandnew/svg/icon-dropdown.svg' role='presentation' ></div>");
    }

    $("#sfoglia_gallery").on("click", function(){
        openGallery();
    });

});

function openGallery(){
    $("html").animate({scrollTop: 0}, 500);

    $(".rds-container.single_post").append(template);
    $("#titolo_page_gallery").text($("h1.title_single_post").text());


    var sub = "";
    for (const item of gallery) {

        console.log(item);


        sub +=  `<div class=" single_slide_gallery_post pos_relative" data-titolo="${item.link}" data-date="" data-categoria="${Utils.quotesToHtmlEntities(item.descrizione)}">
                    <img src="${item.photo}"/>
                </div>`;
    }

    var subtemplate=`
                    <div class="flex_container_gallery" >
                        <div class="cont_slide_overflow">
                            <div id="swipe_gallery" class="flex left_section_gallery">
                                ${sub}
                            </div>
                            <div class="little_parallelograms_gallery">
                                <img class="para_left slider_backward shrink clickable" src="https://media.rds.it/web/web-site-brandnew/svg/arrow_left_blue.svg">
                                <img class="para_right slider_forward shrink clickable" src="https://media.rds.it/web/web-site-brandnew/svg/arrow_right_white.svg">
                            </div>
                        </div>
                        <div class="right_section_gallery">
                            <div>
                                <div class="paginatore_gallery flex" >

                                </div>
                                <div id="post-gallery-link" class="font_28 bold sofia_font">${gallery[0].link}</div>
                                <div id="post-gallery-description" class="font_18 sofia_font">${gallery[0].descrizione}</div>
                            </div>

                        </div>
                     </div>`;

    $('#post-gallery-container').append(subtemplate);

    new PostGallery({
        total: gallery.length,
        paginator_cont: $(".paginatore_gallery"),
        cssVar: '--post_gallery',
        slide_cont: 'left_section_gallery',
        swipeElementSelector: '#swipe_gallery'
    });
}

$(document).on("click", "#chiudi_gallery",function(){
    $("#gallery_cont").remove();
});



class PostGallery {
    constructor({total, paginator_cont, cssVar, slide_cont, swipeElementSelector}){
        this.total=total;
        this.paginator_cont=paginator_cont;
        this.cssVar=cssVar;
        this.slide_cont=slide_cont;

        this.swipeElementSelector=swipeElementSelector;
        this.container=$(this.swipeElementSelector);
        this.images=this.container.children();
        this.currentImageNum=0;
        this.init(total,cssVar);
    }

    init(total, cssVar, paginator_cont) {

        if(total)  this.total = total;
        if(cssVar)  this.cssVar = cssVar;
        if(paginator_cont)  this.paginator_cont = paginator_cont;

        this.container.html('');
        this.createImages(0);
        this.createPallini(this.total, this.paginator_cont);

        try {
            this.addListeners();
        } catch (error) {
            $( window ).off('resize', this.onresize);
        }
    }
    createPallini(total, paginator){

        // let template = `<ul class="h-list">`;
        //
        // if(this.total >=3){
        //     for (let i = 0; i < this.total; i++) {
        //         let selected = i === 0 ? 'selected' : '';
        //         let hidden = i >= 2 ? 'hidden_paginator' : '';
        //         template += `<li data-idx="${i + 1}" class="paginator ${selected} ${hidden}"></li>`
        //     }
        // }else{
        //     for (let i = 0; i < this.total; i++) {
        //         let selected = i === 0 ? 'selected' : '';
        //         template += `<li data-idx="${i + 1}" class="paginator ${selected}"></li>`
        //     }
        // }
        //
        // template += `</ul>
        //     <div class="paginator-index"><span>1/${this.total}</span></div>
        //     `;
        //
        // if(this.total != 1){
        //     paginator.append(template);
        // }

        let template = `<ul class="h-list">`;
        for (let i = 0; i < total; i++) {
            let selected = i === 0 ? 'selected' : '';
            template += `<li data-idx="${i + 1}" class="paginator_square ${selected}"></li>`
        }
        template += `</ul>`;
        paginator.append(template);
    }

    createImages(num){
        return new Promise((resolve,reject)=>{
            $(this.swipeElementSelector).removeClass(this.slide_cont);
            $('.single_slide_home').removeClass('current');
            const initializing=this.container.children().length==0;
            let isBack=parseInt(getComputedStyle(document.documentElement).getPropertyValue(this.cssVar))<0;
            // root.style.setProperty(this.cssVar, 1);
            if(!initializing &&isBack){
                $(this.container.children()[2]).remove();
                $(this.container.children()[1]).remove();
            }else if(!initializing){
                $(this.container.children()[1]).remove();
                $(this.container.children()[0]).remove();
            }
            this.container.css('transform','translate(0)');
            this.currentImageNum=num;
            const current=this.images[num];

            $(current).addClass('current');

            const prev=num==0?this.images[this.images.length-1]:this.images[num-1];
            const next=num==this.images.length-1?this.images[0]:this.images[num+1];
            if(initializing){
                this.container.append(current);
            }
            this.container.append(next);
            this.container.prepend(prev);
            this.container.css('transform','translate(-100%, 0)');
            setTimeout(()=>{
                $(this.swipeElementSelector).addClass(this.slide_cont);
                resolve();
            },200);
        });
    }

    async doScroll(direction){
        if(direction){
            if(scrollArr.length){
                scrollArr.push(()=>this.getScroll(direction));
                return;
            }
            scrollArr.push(()=>this.getScroll(direction));
        }else if(!scrollArr.length){
            return;
        }
        const _scrollArr=scrollArr.slice();
        for (let i = 0; i < _scrollArr.length; i++) {
            const promise = _scrollArr[i];
            const _start=new Date().getTime();
            await promise();
        }
        scrollArr.splice(0, _scrollArr.length);
        this.doScroll();
    }

    getScroll(direction){
        let num=this.currentImageNum;
        let idx = num + 2;

        if(num == this.total - 1){
            idx = 1;
        }

        //
        // $(".paginator_square").removeClass("selected");
        // $(".paginator_square[data-idx='" + idx + "']").addClass("selected");

        return new Promise((resolve,reject)=>{
            let newNum=0;
            if(direction==-1){
                newNum=num==0?this.images.length-1:num-1;
                root.style.setProperty(this.cssVar, -1);
                this.container.css('transform','translate(0, 0)');
            }else{
                newNum=num==this.images.length-1?0:num+1;
                root.style.setProperty(this.cssVar, 1);
                this.container.css('transform','translate(-200%, 0)');
            }

            var titolo = $(this.images[newNum]).attr("data-titolo");
            var date = $(this.images[newNum]).attr("data-date");
            var categoria = $(this.images[newNum]).attr("data-categoria");
            this.fillSlide(titolo, date, categoria);
            $(".paginator_square").removeClass("selected");
            var idx = newNum + 1;
            $(".paginator_square[data-idx='" + idx + "']").addClass("selected");
            setTimeout(()=>{
                this.createImages(newNum).then(()=>{resolve()});
            },TRANSITION_DURATION);
        });
    }

    fillSlide(titolo, data, categoria){
        // $(".fade_effect").fadeOut(function(){
            $("#post-gallery-link").text(titolo);
            $("#post-gallery-description").text(categoria);
            $("#data_current_slide").text(data);
            $(".fade_effect").fadeIn();
        // });

    }


    addListeners() {
        $(".slider_forward").on('click',()=>{this.doScroll(1)});
        $(".slider_backward").on('click',()=>{this.doScroll(-1)});




        if(this.swipeElementSelector){
            const el = document.querySelector(this.swipeElementSelector);
            el.addEventListener('touchstart', (e) => {
                this.handleStart(e);
            }, false);
            el.addEventListener('touchend', (e) => { this.handleEnd(e); }, false);
            el.addEventListener('touchmove', (e) => { this.handleMove(e); }, false);
        }
    }

    handleStart(evt) {


        const touches = evt.changedTouches;
        data.xPos = touches[0].clientX;
        data.yPos = touches[0].clientY;
        data.partialXPos = 0;
        data.partialYPos = 0;
    }


    async handleMove(evt) {


        const element = evt.currentTarget;
        const touches = evt.changedTouches;
        const diffY = touches[0].clientY - data.yPos;
        const diffX = touches[0].clientX - data.xPos;
        let horizontalScroll = true;
        if (Math.abs(diffY) > Math.abs(diffX)) {
            horizontalScroll = false;
        }



        for (const key in DIRECTIONS) {
            const direction = DIRECTIONS[key];
            let diff = touches[0][direction.touchClient] - data[direction.pos];
            if (!horizontalScroll) {
                return;
            }
            evt.preventDefault();

            if (direction.checkHandleCondition(diff) && Math.abs(diff) >= TOLERANCE && !handling) {
                data[direction.pos] = touches[0][direction.touchClient];
                if(direction.name==='left'){
                    // $('.paginator.selected').next().click();
                    console.log("left");
                    handling = true;
                    await this.doScroll(1);
                    handling = false;

                }else{
                    // $('.paginator.selected').prev().click();
                    console.log("right");
                    handling = true;
                    await this.doScroll(-1);
                    handling = false;



                }


            } else if (direction.checkHandleCondition(diff) && Math.abs(diff) < TOLERANCE) {
                diff = diff - data[direction.partialPos];
            }
        }
    }

    handleEnd(evt) {

        if (handling) {
            return;
        }
        const element = evt.currentTarget;

        data.xPos = 0;
        data.yPos = 0;
    }


}
export {PostGallery};

